var map = {
	"./ArrowDownIcon": 9793,
	"./ArrowLeftRightIcon": 2079,
	"./ArrowUpDownIcon": 8918,
	"./ArrowUpIcon": 6088,
	"./BeginnerAnalysisIcon": 7658,
	"./ChatBubbleIcon": 9352,
	"./CloseIcon": 8982,
	"./DashboardIcon": 5750,
	"./DocumentTextIcon": 412,
	"./DollarIcon": 5279,
	"./DotVRIcon": 6298,
	"./EditIcon": 3548,
	"./EyeIcon": 3721,
	"./HeatmapIcon": 6052,
	"./HomeIcon": 8805,
	"./LockIcon": 3328,
	"./MinusCircleIcon": 5636,
	"./NineDotsIcon": 2436,
	"./PlusCircleIcon": 1685,
	"./PulseIcon": 8552,
	"./RibbonIcon": 3033,
	"./ScreenIcon": 2827,
	"./SingleStockAnalysisIcon": 2707,
	"./StockAssistantIcon": 6847,
	"./TechnicalAnalysisIcon": 7074,
	"./TrashIcon": 4599,
	"./UserIcon": 6780,
	"./barIcon": 2168,
	"./clipboardIcon": 3102,
	"./fundemantalIcon": 1916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4386;